import { render, staticRenderFns } from "./kpiMapping.vue?vue&type=template&id=10fc985c&scoped=true&"
import script from "./kpiMapping.vue?vue&type=script&lang=js&"
export * from "./kpiMapping.vue?vue&type=script&lang=js&"
import style0 from "./kpiMapping.vue?vue&type=style&index=0&id=10fc985c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc985c",
  null
  
)

export default component.exports